import CommandCenterHeader from "@components/CommandCenterHeader/CommandCenterHeader";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  PlanGenerationAttemptOut,
  useAutomationIntegrationApiV1GetAutomationMetricsQuery,
} from "@providers/hop-ord-server/api";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import MetricsTable from "./components/MetricsTable";
import MetricsSummary from "./components/MetricsSummary";
import { Role } from "@enums";
import { useCheckUserRole } from "@utils/useCheckUserRole";
import { useNavigate } from "react-router-dom";

const Metrics = () => {
  const isAdmin = useCheckUserRole(Role.ADMIN);
  const navigate = useNavigate();
  if (!isAdmin) {
    navigate("/error");
  }

  const [startDate, setStartDate] = useState<Dayjs>(() =>
    dayjs().subtract(30, "day"),
  );
  const [endDate, setEndDate] = useState<Dayjs>(() => dayjs());

  const { data, isLoading, isError } =
    useAutomationIntegrationApiV1GetAutomationMetricsQuery(
      {
        startDate: startDate.startOf("day").toISOString(),
        endDate: endDate.endOf("day").toISOString(),
      },
      {
        skip: !startDate || !endDate || startDate.isAfter(endDate),
      },
    );

  const rows: PlanGenerationAttemptOut[] = Array.isArray(data) ? data : [];

  const showMetrics = !isLoading && !isError && rows.length > 0;

  return (
    <Stack
      gap={3}
      padding={2}
      height={1}
      maxHeight={1}
      width={1}
      maxWidth="1700px"
      minWidth="1700px"
      marginLeft="auto"
      marginRight="auto"
    >
      <CommandCenterHeader title="Plan Generation Metrics" />
      {isLoading && <CircularProgress />}
      <Stack direction="row" spacing={2} alignItems="center">
        <Stack spacing={2}>
          <Button
            variant="outlined"
            onClick={() => {
              setStartDate(dayjs().subtract(30, "day"));
              setEndDate(dayjs());
            }}
          >
            Reset to Last 30 Days
          </Button>
          <DatePicker
            label="Start date"
            value={startDate}
            onChange={(v) => v && setStartDate(v)}
            format="YYYY-MM-DD"
          />
          <DatePicker
            label="End date"
            value={endDate}
            onChange={(v) => v && setEndDate(v)}
            format="YYYY-MM-DD"
          />
        </Stack>
        <MetricsSummary rows={rows} />
      </Stack>
      {!rows.length && (
        <Typography variant="body2" color="text.secondary">
          No data found
        </Typography>
      )}
      {showMetrics && <MetricsTable rows={rows} />}
    </Stack>
  );
};

export default Metrics;
